import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { LoanApplication_Create, LoanApplication_Delete, LoanApplication_ReadAll, LoanApplication_ReadById, LoanApplication_Update } from "src/app/GlobalVariable";
import { LoanApplication_CreditEngineData, LoanApplication_ExecuteFraudDetection, LoanApplication_ReadAllPaginated, LoanApplication_ReadByBusinessId, LoanApplication_ReadByProductId, LoanApplication_ReadBySubUserId, LoanApplication_ReadByUserId } from './../../GlobalVariable';
import { FraudDetectionMasterDTO } from './loan-application-details/fraud-detection/FraudDetectionMaster/fraudDetectionMaster.interface';
import { ApplicationExecuteFraudDetectionRequestDTO, CreditEngineDataRequest, CreditEngineDataResponse, LoanApplicationCreateDTO, LoanApplicationDeleteDTO, LoanApplicationItem, LoanApplicationList, LoanApplicationReadByBusinessIdDTO, LoanApplicationReadByIdDTO, LoanApplicationReadByProductIdDTO, LoanApplicationReadBySubUserIdDTO, LoanApplicationReadByUserIdDTO, LoanApplicationUpdateDTO } from "./loan-applications.interface";

@Injectable({ providedIn: 'root' })

export class LoanApplicationService {

    http = inject(HttpClient)

    // Create
    LoanApplication_Create(data: LoanApplicationCreateDTO): Observable<LoanApplicationItem> {
        return this.http.post<LoanApplicationItem>(LoanApplication_Create, data);
    }

    //Update
    LoanApplication_Update(data: LoanApplicationUpdateDTO): Observable<LoanApplicationItem> {
        return this.http.post<LoanApplicationItem>(LoanApplication_Update, data)
    }

    //Delete
    LoanApplication_Delete(data: LoanApplicationDeleteDTO): Observable<void> {
        return this.http.post<void>(LoanApplication_Delete, data)
    }
    //ReadAll
    LoanApplication_ReadAll(): Observable<LoanApplicationList> {
        return this.http.get<LoanApplicationList>(LoanApplication_ReadAll)
    }
    //ReadById
    LoanApplication_ReadById(data: LoanApplicationReadByIdDTO): Observable<LoanApplicationItem> {
        return this.http.post<LoanApplicationItem>(LoanApplication_ReadById, data)
    }
    //ReadByUserId
    LoanApplication_ReadByUserId(data: LoanApplicationReadByUserIdDTO): Observable<LoanApplicationList> {
        return this.http.post<LoanApplicationList>(LoanApplication_ReadByUserId, data)
    }
    //ReadByProductId
    LoanApplication_ReadByProductId(data: LoanApplicationReadByProductIdDTO): Observable<LoanApplicationList> {
        return this.http.post<LoanApplicationList>(LoanApplication_ReadByProductId, data)
    }
    //ReadByBusinessId
    LoanApplication_ReadByBusinessId(data: LoanApplicationReadByBusinessIdDTO): Observable<LoanApplicationList> {
        return this.http.post<LoanApplicationList>(LoanApplication_ReadByBusinessId, data)
    }
    // ReadBySubUserId
    LoanApplication_ReadBySubUserId(data: LoanApplicationReadBySubUserIdDTO): Observable<LoanApplicationList> {
        return this.http.post<LoanApplicationList>(LoanApplication_ReadBySubUserId, data)
    }
    LoanApplication_ReadAllPaginated(data: PaginatedDTO): Observable<LoanApplicationList> {
        return this.http.post<LoanApplicationList>(LoanApplication_ReadAllPaginated, data)
    }
    LoanApplication_CreditEngineData(data: CreditEngineDataRequest): Observable<CreditEngineDataResponse> {
        return this.http.post<CreditEngineDataResponse>(LoanApplication_CreditEngineData, data)
    }

    Application_ExecuteFraudDetection(data: ApplicationExecuteFraudDetectionRequestDTO): Observable<FraudDetectionMasterDTO> {
        return this.http.post<FraudDetectionMasterDTO>(LoanApplication_ExecuteFraudDetection, data);
    }
}